import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick/skeleton-brick';
import {resolveSkeletonBrickTheme} from '@Components/ai-chat-window/lib/skeleton.library';
import type {EntityCardSkeletonProps} from './entity-card-skeleton.types';
import {SKELETON_CARD_THUMBNAIL_SIZE, SKELETON_META_LINE_WIDTH, SKELETON_TEXT_LINE_HEIGHT, SKELETON_TITLE_LINE_WIDTH} from './entity-card-skeleton.types';
import styles from './entity-card-skeleton.module.scss';

/**
 * Transient placeholder echoing the entity-card shape (a thumbnail plus a title and a meta line). Every
 * brick shares one theme so the image and text read as a single surface: grey while loading, the AI
 * gradient while the agent is generating.
 */
export function EntityCardSkeleton({mode}: EntityCardSkeletonProps): ReactElement {
  const theme = resolveSkeletonBrickTheme(mode);

  return (
    <div className={styles.entityCardSkeleton}>
      <SkeletonBrick className={styles.skeletonThumbnail} width={SKELETON_CARD_THUMBNAIL_SIZE} height={SKELETON_CARD_THUMBNAIL_SIZE} radius="12px" theme={theme} />
      <div className={styles.skeletonText}>
        <SkeletonBrick className={styles.skeletonLine} width={SKELETON_TITLE_LINE_WIDTH} height={SKELETON_TEXT_LINE_HEIGHT} radius="4px" theme={theme} />
        <SkeletonBrick className={styles.skeletonLine} width={SKELETON_META_LINE_WIDTH} height={SKELETON_TEXT_LINE_HEIGHT} radius="4px" theme={theme} />
      </div>
    </div>
  );
}
